import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import BackdropReflectionRadioButton from './BackdropReflectionRadioButton';
import BackdropReflectionDirectionListItem from './BackdropReflectionDirectionListItem';

const BackdropReflectionListItem = (props) => {
    const { backgroundReflectionType, updateBackgroundSettings } = props;

    const onReflectionTypeChange = (value) =>
        updateBackgroundSettings({
            reflection: {
                type: value,
                direction: 1
            }
        });

    return (
        <BackdropReflectionRadioButton
            selectedType={backgroundReflectionType}
            text='Reflection'
            onChange={onReflectionTypeChange}
        >
            <List dense disablePadding>
                <BackdropReflectionDirectionListItem />
            </List>
        </BackdropReflectionRadioButton>
    );
};

const mapStateToProps = (state) => {
    const { type: backgroundReflectionType } = state.createPreview.present.videoSettings.background.reflection;
    return { backgroundReflectionType }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropReflectionListItem);